/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, ref } from "vue";
import CustomDropdown from "./CustomDropdown.vue";

interface Action {
  handler?: (row: unknown) => void;
}

interface TableColumn {
  label?: string;
  format?: string | ((d: unknown) => string);
}

export default defineComponent({
  name: "c-table",
  props: {
    columns: { type: Array as () => TableColumn[], required: true },
    rows: { type: Array as () => unknown[], required: true },
    actions: {
      type: [Array, Object] as unknown as () =>
        | Action[]
        | Record<string, unknown>,
      default: () => [] as Action[] | Record<string, unknown>,
    },
    dataRows: { type: Array as () => unknown[], default: () => [] },
    styleList: { type: String, default: "max-height: 300px" },
    loading: { type: Boolean, default: false },
    rowOptions: { type: Array as any, default: () => [] },
    isOption: { type: Boolean, default: false },
    hidden: { type: Boolean, default: true },
  },

  emits: ["handler", "onSelectTableAction"],

  data() {
    return {
      isSecondLoading: false,
      textLoading: "onboardProcessing",
      localDataRows: [] as unknown[],
      tableRowOptions: null,
    };
  },

  computed: {
    isLoading(): boolean {
      return this.loading;
    },
  },

  components: {
    CustomDropdown,
  },

  methods: {
    onChangeDropdown(item: any): void {
      this.$emit("onSelectTableAction", item);
    },

    async loadData(): Promise<void> {
      if (this.dataRows && this.dataRows.length) {
        this.isSecondLoading = true;
      }

      try {
        // Simulated data loading with a timeout
        let index = 0;
        const batchSize = 100;
        const totalRecords = this.dataRows.length;
        const newDataRows: unknown[] = [];

        if (totalRecords > batchSize) {
          this.textLoading = "onboardBigDataProcessing";
        }

        while (index < totalRecords) {
          // Simulate fetching a batch of records
          const batch = this.dataRows.slice(index, index + batchSize);

          // Delay for 1000 milliseconds before updating dataRows
          await new Promise((resolve) => setTimeout(resolve, 1000));

          // Update newDataRows with the batch of records
          newDataRows.push(...batch);

          // Move to the next batch
          index += batchSize;
        }

        // Set dataRows to the new array after all data is loaded
        this.localDataRows = newDataRows;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        // Set isSecondLoading to false after data loading completes or in case of error
        this.isSecondLoading = false;
      }
    },

    emitHandler(): void {
      this.$emit("handler");
    },

    handleAction(action: Action, row: unknown): void {
      action?.handler?.(row);
    },

    handleCondition(
      item: { condition?: (row: unknown) => string },
      row: unknown
    ): string {
      return item?.condition?.(row) || "";
    },

    tdValue(a: TableColumn, b: Record<string, unknown>): string | unknown {
      let d: string | Record<string, unknown> = b;
      const c = a?.label?.split(".");

      if (c && c.length > 0) {
        for (const labelPart of c) {
          const labelParts = labelPart?.split("-");
          if (labelParts && labelParts.length > 1) {
            const concatenatedValue = ref<string[]>([]);

            for (const part of labelParts) {
              const value = (d as Record<string, unknown>)[part] as
                | string
                | undefined;
              concatenatedValue.value.push(value || "");
            }

            d = concatenatedValue.value.join(" ");
          } else {
            d = (d as Record<string, unknown>)[labelPart] as
              | string
              | Record<string, unknown>;
          }
        }
      }

      if (a?.format === "n/a") {
        return d ? String(d) : "N/A";
      }

      if (a?.format === "0") {
        return d ? String(d) : "0";
      }

      return typeof a.format === "function" ? a.format(d) : String(d);
    },

    splitFunc(): void {
      console.log("data listing");
    },

    className(className: string | undefined): string {
      const c = className ? className.split(/\s+/) : [];

      return c.length ? c[0] + "-disabled" : "";
    },

    handleScroll(): void {
      const tableBody = this.$refs.tableBody as HTMLElement;
      if (
        tableBody.scrollTop + tableBody.clientHeight >=
        tableBody.scrollHeight
      ) {
        // return [
        //   tableBody.scrollTop,
        //   tableBody.clientHeight,
        //   tableBody.scrollHeight,
        // ];
      }
    },
  },
});
